<template>
    <div>
        <div class="card-header text-lg">
            {{$t("CheckoutCompletePayBillByCheck.youPayedByCheck")}}
        </div>
        <div class="card-body">
            <div class="row align-items-center">
                <div class="col-1 mr-2">
                    <i class="fas fa-money-check-alt fa-3x"></i>
                </div>
                <div class="col-10">
                    <h4 class="card-title">{{$t("CheckoutCompletePayBillByCheck.howByCheck")}}</h4>
                </div>
            </div>
            <hr class="mb-4"/>
            <div class="row form-group">
                <label class="col-2 col-form-label text-muted" for="title">{{$t("CheckoutCompletePayBillByCheck.to")}}</label>
                <input v-tooltip="$t('CheckoutCompletePayBillByCheck.clickToCopy')" class="form-control col-8" readonly id="title"
                       @click="copy('title')" :value="shop.displayedName"/>
            </div>
            <div class="row form-group">
                <label class="col-2 col-form-label text-muted" for="amount">{{$t("CheckoutCompletePayBillByCheck.amount")}}</label>
                <input v-tooltip="$t('CheckoutCompletePayBillByCheck.clickToCopy')" class="form-control col-8" readonly id="amount"
                       @click="copy('amount')" :value="properPrice(order.totalWT, order.currency, currencies)"/>
            </div>
            <div class="row form-group">
                <label class="col-2 col-form-label text-muted" for="title">{{$t("CheckoutCompletePayBillByCheck.recipient")}}</label>
                <input v-tooltip="$t('CheckoutCompletePayBillByCheck.clickToCopy')" class="form-control col-8" readonly id="recipient"
                       @click="copy('recipient')" :value="payments.check.recipient"/>
            </div>
            <div class="row form-group">
                <label class="col-2 col-form-label text-muted" for="title">{{$t("CheckoutCompletePayBillByCheck.reference")}}</label>
                <input v-tooltip="$t('CheckoutCompletePayBillByCheck.clickToCopy')" class="form-control col-8" readonly id="reference"
                       @click="copy('reference')" :value="order.reference"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { properPrice } from "../../../../helpers/price";

export default {
    name: "CheckoutCompletePayBillByCheck",
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters("currencies", {
            currencies: "currencies",
        }),
        ...mapGetters("config", {
            shop: "shop",
            payments: "payments",
        }),
    },
    methods: {
        properPrice,
        copy(id) {
            const copyText = document.getElementById(id);
            copyText.select();
            document.execCommand("copy");
            this.$toasted.success(this.$t("CheckoutCompletePayBillByCheck.copied"), { icon: "copy" });
        },
    },
};
</script>

<style scoped>
    input[readonly="readonly"] {
        cursor: pointer;
        color: #606060;
    }
</style>